import { memo } from 'react';
import { cn } from '../../../utils/string/cn.utils';

const ButtonIconOutlineLarge = ({ id, icon, ...props }) => {
  return (
    <button
      id={id}
      type="button"
      {...props}
      className={cn(
        'disabled:cursor-not-allowed disabled:pointer-events-none bg-fills-white border-[1px] border-solid border-outline-default-secondary flex justify-center items-center hover:border-outline-brand-primary hover:bg-primary-primaryFill disabled:border-outline-default-disable disabled:text-black-low disabled:bg-fills-disable text-black-high',
        'gap-[10px] w-[40px] min-w-[40px] h-[40px] min-h-[40px] p-[4px] rounded-[100px]',
        props.className
      )}
    >
      {icon && (
        <div className="w-24 h-24 flex justify-center items-center">{icon}</div>
      )}
    </button>
  );
};

export default memo(ButtonIconOutlineLarge);
